import { render, staticRenderFns } from "./FutureTransportsPopup.vue?vue&type=template&id=4b158cb4&scoped=true&"
import script from "./FutureTransportsPopup.vue?vue&type=script&lang=ts&"
export * from "./FutureTransportsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./FutureTransportsPopup.vue?vue&type=style&index=0&id=4b158cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b158cb4",
  null
  
)

export default component.exports